import { store } from '../../store'
import { http, httpgst, httpgstgzip } from '../../main'

const state = {}

const getters = {}

const actions = {
  get ({ commit, dispatch }, payload) {
    let url = payload.event.item.isInternational ? `api/expenses-report-user-int/${payload.event.item.url}` : `api/expenses-report-user/${payload.event.item.url}`
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, {}, options)
      .then(
        response => {
          commit('onGet', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  downloadUserSummary({ commit, dispatch }, payload) {
    let url =  `api/expenses-report-user-summary/${payload.event.item.url}`

    let options = {
      emulateJSON: false,
      headers: { 'Content-Type': 'application/pdf' }
    }

    let params = {
      responseType: 'blob'
    }

    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgst.get(url, params, options).then(
      response => {
        commit('onDownloadRequest', { event: payload.event, response: response })
      },
      error => {
        commit('onError', { event: payload.event, error: error })
      }
    )
  },
  downloadReport ({ commit, dispatch }, payload) {
    let url = payload.event.item.isInternational ? `api/expenses-report-user-download-int/${payload.event.item.url}` : `api/expenses-report-user-download/${payload.event.item.url}`
    let options = {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    let params = {
      data: payload.event.context.data
    }
    httpgstgzip.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgstgzip.patch(url, params, options)
      .then(
        response => {
          commit('onDownloadReport', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  downloadReportByList ({ commit, dispatch }, payload) {
    let url = `api/expenses-report-user-download-list/${payload.event.item.companyId}`
    let options = {
      responseType: 'blob',
      headers: {
        'Content-Type': 'application/json'
      }
    }
    let params = {
      expenses: payload.event.item.listId
    }
    httpgstgzip.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    httpgstgzip.patch(url, params, options)
      .then(
        response => {
          commit('onDownloadReport', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  getCompanyEmployee ({ commit, dispatch }, payload) {
    let url = `api/user-company/${payload.event.item.companyId}`
    let options = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    httpgst.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetCompanyEmployees', { event: payload.event, response: response })
        },
        error => {
          commit('onError', { event: payload.event, error: error })
        }
      )
  },
  getLogged ({ commit, dispatch }, payload) {
    let url = 'api/user-logged'
    let options = {
      emulateJSON: false,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    http.defaults.headers.common['Authorization'] = 'Bearer ' + store.state.userState.access_token
    http.defaults.headers.common['X-device'] = 'WEB'
    http.get(url, {}, options)
      .then(
        response => {
          commit('onGetLogged', {event: payload.event, response: response})
        },
        error => {
          commit('onError', {event: payload.event, error: error})
        }
      )
  }
}

const mutations = {
  onGet (state, payload) {
    const reports = payload.response.data.data.reportData
    payload.event.context.data = reports
    let expensesItems = payload.response.data.data.expensesItemsByMonth
    if (expensesItems !== null) {
      let months = Object.getOwnPropertyNames(expensesItems)
      let newItems = []
      for (let i = 0; i < months.length; i++) {
        const item = months[i]
        if (item !== '0') {
          let temp = {
            month: parseInt(item),
            items: expensesItems[item]
          }
          newItems.push(temp)
        }
      }
      expensesItems = newItems
    }
    payload.event.context.expensesItems = expensesItems
    payload.event.context.showResult = true
    payload.event.context.processDetailedData()
    payload.event.context.close()
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
    payload.event.context.loadingDownload = false
  },
  onGetLogged (state, payload) {
    let userLogged = payload.response.data.data
    payload.event.context.userLogged = userLogged
    payload.event.context.getEmployees()
  },
  onGetCompanyEmployees (state, payload) {
    const employees = payload.response.data.data.users
    payload.event.context.employees = employees
    if (payload.event.context.search) {
      payload.event.context.search()
    }
  },
  onError (state, payload) {
    if (payload.error.response.data.errors !== undefined) {
      payload.event.context.errors = payload.error.response.data.errors
    }
    if (payload.error.response.status === 401) {
      payload.event.context.showNotification(payload.event.context.$t('login.sessionExpired'), 'error', -1)
      setTimeout(() => { payload.event.context.$router.push({ name: 'LoginPage' }) }, 2000)
    } else {
      payload.event.context.showNotification(payload.error.response, 'error', -1)
    }
    payload.event.context.loading = false
    payload.event.context.loadingItems = false
    payload.event.context.loadingDownload = false
  },
  onDownloadReport (state, payload) {
    let date = payload.event.context.getReportDate()
    payload.event.context.forceFileDownload(payload.response.data, payload.event.context.detail ? 'ExpensesUsers-Detailed' + ` ${date}.xlsx` : 'ExpensesUsers' + ` ${date}.xlsx`)
    payload.event.context.downloadLoading = false
    if(payload.event.context.expensesIds.length > 0) payload.event.context.closeDialogReportByList()
  },
  onDownloadRequest(state, payload) {
    const contentType = payload.response.headers['content-type']

    let extension = 'xlsx'

    if (contentType.includes('spreadsheet')) extension = 'xlsx'
    else if (contentType.includes('csv')) extension = 'csv'
    else if (contentType.includes('json')) extension = 'json'

    payload.event.context.forceFileDownload(payload.response.data, 'Resumen_por_empleado.' + extension)

    payload.event.context.downloadLoading = false
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/expenseDetailEmployee.js